import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../../context/LoaderContext";
import List from "./List";
import { fetchBannerList } from "../../../redux/slice/bannerSlice";
import { useNavigate, useNavigationType } from "react-router-dom";

const Banners = () => {
  const dispatch = useDispatch();
  const { setLoading } = useLoader();
  const headerPortalTarget = document.getElementById("header-portal-target");

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h4 className="fw-semibold mb-0 text-primary fs-lg">
        <span className="text-muted fw-normal">Banner / </span>Banners
      </h4>
    </div>
  );
  const navigationType = useNavigationType();
  const [
    limit,
    setLimit
  ] = useState(() => {
    if (navigationType === "POP") {
      const savedLimit = sessionStorage.getItem("banner_limit");
      if (savedLimit) return JSON.parse(savedLimit);
    }
    return { value: 10, label: 10 };
  });
  // Redux
  const { list = [], isLoading, total } = useSelector((state) => state.banners || {});

  // Local state 
  const [searchTerm, setSearchTerm] = useState(() => {
    if (navigationType === "POP") {
      return sessionStorage.getItem("banner_searchTerm") || "";
    }
    return "";
  });

  const [currentPage, setCurrentPage] = useState(() => {
    if (navigationType === "POP") {
      const savedPage = sessionStorage.getItem("banner_page");
      if (savedPage) return parseInt(savedPage, 10);
    }
    return 1;
  });


  const [isEdit, setIsEdit] = useState(false);
  const navigate = useNavigate();

  const isInitialLoadRef = useRef(true);
  const searchTimeout = useRef(null);

  // Save to sessionStorage
  sessionStorage.setItem("banner_limit", JSON.stringify(limit));
  sessionStorage.setItem("banner_page", currentPage.toString());
  sessionStorage.setItem("banner_searchTerm", searchTerm);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    const fetchData = () => {
      if (isInitialLoadRef.current) {
        setLoading(true);
      }
      dispatch(
        fetchBannerList({
          search: searchTerm,
          page: currentPage,
          limit: limit?.value,
        })
      ).finally(() => {
        if (isInitialLoadRef.current) {
          setLoading(false);
          isInitialLoadRef.current = false;
        }
      });
      // dispatch(fetchBannerList()); 
    };
    if (isInitialLoadRef.current) {
      fetchData();
    } else {
      searchTimeout.current = setTimeout(fetchData, 300);
    }

    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, [dispatch, searchTerm, currentPage, limit.value, setLoading]);

  // useEffect(() => {
  //   setLoading(isLoading);
  // }, [isLoading, setLoading]);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const handleEditBtn = (item) => {
    setIsEdit(true);
    navigate(`/edit-banner/${item.title}`, {
      state: { item, isEdit: true },
      id: item.id,
    });
  };


  const paginationConfig = useMemo(() => ({
    currentPage,
    totalPages: Math.ceil(total / limit?.value) || 1,
    total: total || 0,
    onPageChange: (page) => setCurrentPage(page),
    pageSize: limit?.value,
    setPageSize: (size) => setLimit({ value: size, label: size }),
    setCurrentPage
  }), [currentPage, total, limit]);

  return (
    <>
      {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}

      <Container fluid className="px-0">
        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
          {/* List */}
          <List
            data={list}
            isLoading={isLoading}
            isInitialLoad={isInitialLoadRef.current}
            searchTerm={searchTerm}
            setSearchTerm={handleSearchChange}
            setCurrentPage={setCurrentPage}
            handleEditBtn={handleEditBtn}
            isEdit={isEdit}
            pagination={paginationConfig}
          />
        </div>
      </Container>
    </>
  );
};

export default Banners;
